<template>
    <div v-bind:class="'alert-'+alertMessage.alert_context" class="alert alert-block alert">

        <div class="alert alert-success" v-if="successAlert">
            <strong>{{"Picture is pending approval"|trans}}</strong>
        </div>
        <div v-else>

            <Spinner v-bind:title="'Sending ...'" v-if="isSaving" ></Spinner>

            <div  @click="$emit('openAlert')" class="title-message-open-alert strong" v-show="!isSaving">
                <div class="col-12">
                    <p class="alert_title">{{ 'please_add_logo'|trans }}
                    <template v-if="alertMessage.isConfirmationMessageOpen ">
                        <i class="fa fa-times pull-right  "></i>
                    </template>
                    <template v-else>
                        <i class="fa fa-envelope pull-right  "></i>
                    </template>
                    </p>
                </div>
            </div>

            <div class="confirmation_message" v-show="alertMessage.isConfirmationMessageOpen && !isSaving ">

                <div class="row">
                    <div class="col-xs-12">
                        <p>{{ alertMessage.message }}</p>
                        <p class="f-red">{{ 'picture_logo_warning'|trans }}</p>
                        <div class="row" v-if="isImageUploaded === false">
                            <div class="col-xs-4 ">
                                <img src="/img/examples/example-logo.png" width="100%">
                            </div>
                            <div class="col-xs-4 ">
                                    <img src="/img/examples/example-car-logo.png" width="100%">
                            </div>
                            <div class="col-xs-4 ">
                                <img src="/img/examples/example-profile.png" width="100%">
                            </div>
                        </div>
                        <UploadWorkerLogo
                        v-bind:workerId="workerId"
                        v-on:enableSubmitButton="disableSubmitButton = $event"
                        v-on:isImageUploaded="isImageUploaded = $event"
                        >
                        </UploadWorkerLogo>
                    </div>
                    <div class="col-xs-3">
                        <button class="btn btn-primary" @click="submitResponse()" v-bind:disabled="disableSubmitButton" >{{ 'send'|trans }} </button>
                    </div>
                    <div class="col-xs-9">
                        <button @click="$emit('snoozeAlert', defaultSnoozeHours)" class="btn btn-primary f-right" v-bind:disabled="isSnoozedTimerEnable">{{'Reminder in 2h'|trans}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../../Spinner';
    import UploadWorkerLogo from '../../UploadWorkerLogo';

    export default {
        props: {
            alertMessage : Object,
            isSnoozedTimerEnable : false,
            workerId: null,
        },
        data(){
            return {
                defaultSnoozeHours : 2,
                isSaving: false,
                file: null,
                disableSubmitButton: true,
				isImageUploaded: false,
				successAlert: false
            }
        },
        methods: {
            async submitResponse() {
                this.isSaving = true;
                try {
					this.successAlert = true;
                	await this.$api.alert.responseOfAlertMissingWorkerLogo(this.alertMessage);
					setTimeout(() => {
						this.$emit('hideAlert');
						this.successAlert = false;
						},
                        4000);

                } catch (error) {
                    alert('Ooops ! Please retry later ...');
                }
                this.isSaving = false;
            }
        },
        components: {
            Spinner,
            UploadWorkerLogo
        },
        filters: {
            TruncateJobNumber(value) {
                return value.toString().substr(2, value.toString().length);
            },
        }
    }
</script>
<style scoped>
    .strong{
        font-weight: bold;
    }
    .f-right{
        float: right;
    }
    .f-red{
        color: #ff4b18;
    }
    .example_logo{
        width: 50px;
        height: 50px;
    }
    .text-title{
        text-align: center;
        font-weight: 600;
        text-decoration: underline;
        margin-top: 15px;
        margin-bottom: 30px;
    }
    .invalid{
        filter: blur(3px);
        -webkit-filter: blur(3px);
    }
    .t-center{
        text-align: center;
    }

</style>
